import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Layout, Download, Library, Dice1 } from "lucide-react";

const deckTools = [
  {
    title: "Deck Builder",
    description: "Pick a division and build or edit a list. The main editor for competitive decks.",
    path: "/deck-builder",
    icon: Layout,
  },
  {
    title: "Import Deck",
    description: "Paste a deck code from the game to open it in the builder or preview.",
    path: "/deck-import",
    icon: Download,
  },
  {
    title: "Deck Library",
    description: "Browse published decks from the community and open them in the builder.",
    path: "/deck-library",
    icon: Library,
  },
  {
    title: "Deck Drafter",
    description: "Draft a deck step by step with random choices—good for experiments or constraints.",
    path: "/deck-drafter",
    icon: Dice1,
  },
];

export function DecksHub() {
  return (
    <div className="container mx-auto max-w-4xl px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold tracking-tight">Decks</h1>
        <p className="mt-2 text-muted-foreground max-w-2xl">
          Everything for building, importing, sharing, and experimenting with decks. Start in the builder,
          or use import and the library when you already have a code or want to explore lists others shared.
        </p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        {deckTools.map((tool) => {
          const Icon = tool.icon;
          return (
            <Link key={tool.path} to={tool.path} className="group block h-full">
              <Card className="h-full transition-all duration-200 hover:border-primary/40 hover:shadow-md">
                <CardHeader className="pb-2">
                  <div className="flex items-center gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary">
                      <Icon className="h-5 w-5" />
                    </div>
                    <CardTitle className="text-lg group-hover:text-primary transition-colors">
                      {tool.title}
                    </CardTitle>
                  </div>
                  <CardDescription className="pt-1 text-sm leading-relaxed">
                    {tool.description}
                  </CardDescription>
                </CardHeader>
                <CardContent className="pt-0">
                  <span className="text-sm font-medium text-primary opacity-90 group-hover:opacity-100">
                    Open →
                  </span>
                </CardContent>
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
